var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEmptyQnA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h180v180H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h180v180H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 20)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBDBDB",
    cx: 65.976,
    cy: 65.905,
    rx: 65.976,
    ry: 65.905
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.242 113.676 1.967 19.637a3.96 3.96 0 0 1-5.043 4.198l-19.678-5.707a3.96 3.96 0 0 1-1.346-6.916l17.712-13.93a3.96 3.96 0 0 1 6.388 2.718z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.599 56.298 9.447-1.666a4.8 4.8 0 0 1 5.56 3.893l1.663 9.427a4.8 4.8 0 0 1-3.894 5.561l-9.447 1.666a4.8 4.8 0 0 1-5.56-3.894l-1.663-9.427a4.8 4.8 0 0 1 3.894-5.56zM61.38 59.32h9.592a4.8 4.8 0 0 1 4.8 4.8v9.572a4.8 4.8 0 0 1-4.8 4.8H61.38a4.8 4.8 0 0 1-4.8-4.8v-9.573a4.8 4.8 0 0 1 4.8-4.8zM94.306 54.632l9.447 1.666a4.8 4.8 0 0 1 3.894 5.56l-1.663 9.427a4.8 4.8 0 0 1-5.56 3.894l-9.448-1.666a4.8 4.8 0 0 1-3.893-5.56l1.662-9.428a4.8 4.8 0 0 1 5.56-3.893z",
    fill: "#AAAAAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEmptyQnA);
export default __webpack_public_path__ + "static/media/image_empty_qn_a.e7e1dac836bffb33514b386532cb426c.svg";
export { ForwardRef as ReactComponent };